<template>
  <button
    variant="facebook icon"
    class="sidebar-minimizer"
    type="button"
    @click="onClick()"
  ></button>
</template>
<script>
import { togglePs } from "../../mixins/togglePs";

export default {
  name: "sidebar-minimizer",
  mixins: [togglePs],
  mounted() {
    const isMinimized = document.body.classList.contains("sidebar-minimized");
    this.togglePs(!isMinimized);
  },
  methods: {
    onClick() {
      this.sidebarMinimize();
      this.brandMinimize();
      // tslint:disable:no-console
      console.log("this is called");
    },
    sidebarMinimize() {
      const isMinimized = document.body.classList.toggle("sidebar-minimized");
      this.$emit("cui-sidebar-minimize", isMinimized);
      this.togglePs(!isMinimized);
    },
    brandMinimize() {
      document.body.classList.toggle("brand-minimized");
    },
  },
};
</script>
<style scoped>
.sidebar-minimizer {
  background: #fff !important;
  position: relative;
}
.fa-user {
  color: black !important;
}
</style>
<style>
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .nav-item:hover > .nav-link {
    background: white !important;
    color: black !important;
  }
  .sidebar-minimized .sidebar .sidebar-minimizer {
    position: initial;
    top: 0;
  }
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .nav-item:hover > .nav-link .nav-icon {
    color: #000 !important;
  }
}
.sidebar .sidebar-minimizer::before {
  background-image: url("../../../public/img/png/sidebar-minimize.svg");
  background-size: 26px;
}
.sidebar .sidebar-minimizer::after {
  display: block;
  content: "";
  border-top: 1px solid #d9d9d9;
  width: 164px;
  margin: 0 1rem;
  transform: translateY(-1rem);
  position: absolute;
  top: 77%;
}
.sidebar .sidebar-minimizer:hover::before {
  background-image: url("../../../public/img/png/sidebar-minimize.svg");
}
</style>
